import { DEAL_BOND_DOCUMENT_SEGMENT_EVENTS } from '@/modules/application-tracker/constants';

export const DDSegmentEvents = {
  ...DEAL_BOND_DOCUMENT_SEGMENT_EVENTS,
  LeaseStartDateRangeFilterChanged: 'Deals Dashboard - Lease Start Date Range Filter Changed',
  LeaseEndDateRangeFilterChanged: 'Deals Dashboard - Lease End Date Range Filter Changed',
  DealDrawerOpened: 'Deals Dashboard - Deal details drawer opened',
  DealDrawerClosed: 'Deals Dashboard - Deal details drawer closed',
  ExportSuccess: 'Deals Dashboard - Deals successfully exported',
  ExportFailed: 'Deals Dashboard - Export deals failed',
  ExportingDeals: 'Deals Dashboard - Export deals requested',
  FilterChanged: 'Deals Dashboard - Filter changed',
  SearchBarChange: 'Deals Dashboard - Search Bar input changed',
  TabChanged: 'Deals Dashboard - Tab Changed',
  ApplicationDetailsError: 'Deals Dashboard - Application Details Error',
  DealsDashboardError: 'Deals Dashboard - Dashboard Error',
} as const;

export const SegmentPocApplicationTrackerClientEvents = {
  ApplicationTrackerLoaded: '[PoC] (Client) Application Tracker loaded',
} as const;

export const SegmentPocApplicationTrackerServerEvents = {
  ApplicationTrackerLoaded: '[PoC] (Server) Application Tracker loaded',
} as const;
